export default {"src":"/_next/static/media/image_help_customers_1.8c16885d.svg","height":510,"width":1222,"blurWidth":0,"blurHeight":0};